import React from 'react';

export interface LocationOnProps {
  style?: React.CSSProperties;
}

export const LocationOn = ({ style }: LocationOnProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      style={style}
    >
      <path
        d="M8.00395 10.1905C8.50581 10.1905 8.93411 10.0145 9.28885 9.6627C9.64378 9.31085 9.82124 8.88788 9.82124 8.39378C9.82124 7.89968 9.64247 7.47791 9.28491 7.12847C8.92753 6.77921 8.49792 6.60458 7.99605 6.60458C7.49419 6.60458 7.06589 6.78051 6.71115 7.13235C6.35622 7.4842 6.17876 7.90717 6.17876 8.40127C6.17876 8.89537 6.35754 9.31714 6.7151 9.66658C7.07247 10.0158 7.50209 10.1905 8.00395 10.1905ZM8 19.0102C10.1189 17.1944 11.794 15.3476 13.0255 13.47C14.2569 11.5924 14.8726 9.96848 14.8726 8.59828C14.8726 6.56768 14.2197 4.89169 12.9139 3.57033C11.608 2.24915 9.97006 1.58856 8 1.58856C6.02995 1.58856 4.39199 2.24915 3.08614 3.57033C1.78028 4.89169 1.12736 6.56768 1.12736 8.59828C1.12736 9.96848 1.74308 11.5924 2.97453 13.47C4.20598 15.3476 5.88113 17.1944 8 19.0102ZM8 20.5C5.35071 18.1934 3.35511 16.0422 2.01318 14.0463C0.671058 12.0507 0 10.2347 0 8.59828C0 6.25024 0.776561 4.31351 2.32968 2.78811C3.88261 1.2627 5.77272 0.5 8 0.5C10.2273 0.5 12.1174 1.2627 13.6703 2.78811C15.2234 4.31351 16 6.25024 16 8.59828C16 10.2347 15.3289 12.0507 13.9868 14.0463C12.6449 16.0422 10.6493 18.1934 8 20.5Z"
        fill="#383838"
      />
    </svg>
  );
};

export default LocationOn;
